import ATMLoadProfileBaseController from '../common/atm_load_profile.base.controller'
import AppConstatnt from '../../../../../config/app.constants';

class ATMLoadProfileEditController extends ATMLoadProfileBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams)
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.User = User;
        this.hasACL = {};
        this.rawId = '';

        this.defaultModel = {};
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
    }

    reset() {

    }

    submit() {
    }
}

export default ATMLoadProfileEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/edit/atm_load_profile.edit.controller.js